import { AgGridTable } from 'components/AgGrid/AgGridTable';
import { ConfirmationDialog } from 'components/ConfirmationDialog';
import { ControlledTextField } from 'components/Form';
import { ModalDialog } from 'components/ModalDialog';
import { useMethodsConfirmationDialog } from 'hooks/useMethodsConfirmationDialog';
import { Button, IconInfoCircle, Informer } from 'uikit';

import type { ColDef, ColGroupDef } from 'ag-grid-community';
import { useCallback, useMemo } from 'react';
import type { Control } from 'react-hook-form';

import Styles from './workOrderActsKc2ListGroupManager.module.css';

export const WorkOrderActsKc2ListGroupManager = <T = any,>({
    isOpened,
    handleToggleModalState,
    handleSubmit,
    tableData,
    tableColumns,
    control,
    defaultColDef,
    isLoading,
    isCommit,
    btnClassName,
    btnConfirmDisabled,
    isFormDirty,
    isEdit,
}: {
    isOpened: boolean;
    handleToggleModalState: () => void;
    handleSubmit: () => void;
    tableData: T[];
    tableColumns: (ColDef<T> | ColGroupDef<T>)[];
    control: Control<any>;
    defaultColDef?: ColDef<T>;
    btnClassName?: string;
    isLoading?: boolean;
    isCommit?: boolean;
    btnConfirmDisabled?: boolean;
    isFormDirty?: boolean;
    isEdit?: boolean;
}) => {
    const { handleOpenConfirmationDialog, handleCloseConfirmationDialog, isOpenConfirmationDialog, handleActionQuery } =
        useMethodsConfirmationDialog({
            actionFn: handleToggleModalState,
        });

    const closeHandler = useCallback(() => {
        if (isFormDirty) {
            handleOpenConfirmationDialog();
        } else {
            handleToggleModalState();
        }
    }, [handleOpenConfirmationDialog, handleToggleModalState, isFormDirty]);

    const modalTitle = useMemo(() => (isEdit ? 'Редактирование группы актов' : 'формирование группы актов'), [isEdit]);

    const btnConfirmLabel = useMemo(() => (isEdit ? 'Сохранить' : 'Сформировать'), [isEdit]);

    return (
        <>
            <Button label="Сформировать группу" size="s" onClick={handleToggleModalState} className={btnClassName} />
            <ModalDialog
                isOpen={isOpened}
                title={modalTitle}
                btnConfirmLabel={btnConfirmLabel}
                onConfirm={handleSubmit}
                onClose={closeHandler}
                withTitleCloseButton
                isOnClickOutsideDisable
                bodyWidth={1310}
                bodyMinHeight="400px"
                className={Styles.groupManager}
                isLoading={isLoading}
                isCommit={isCommit}
                btnConfirmDisabled={btnConfirmDisabled}
            >
                <div className={Styles.bodyContainer}>
                    <div className={Styles.nameInput}>
                        <ControlledTextField
                            name="groupName"
                            label="Наименование группы"
                            control={control}
                            type="text"
                            required
                            rules={{ required: 'Обязательное поле' }}
                        />
                    </div>
                    <div className={`ag-theme-alpine ${Styles.workOrderActsKC2ListManager}`}>
                        <AgGridTable columnDefs={tableColumns} rowData={tableData} defaultColDef={defaultColDef} />
                    </div>
                    {!isEdit && (
                        <Informer
                            label="Для создания группы необходимо выбрать хотя бы один Акт КС-2"
                            status="system"
                            icon={IconInfoCircle}
                            className={Styles.informer}
                        />
                    )}
                </div>
            </ModalDialog>
            <ConfirmationDialog
                textHeader="формирование группы актов"
                textConfirmation="Вы уверены, что хотите отменить?"
                cancelButtonText="Не отменять"
                confirmButtonText="Отменить"
                isOpened={isOpenConfirmationDialog}
                onSubmit={handleActionQuery}
                onClose={handleCloseConfirmationDialog}
            />
        </>
    );
};

WorkOrderActsKc2ListGroupManager.displayName = 'BimWorkOrderActsKc2ListGroupManager';
